import { render } from "./add_orthopedic_procedures_modal.vue?vue&type=template&id=13cfc63f&scoped=true"
import script from "./add_orthopedic_procedures_modal.vue?vue&type=script&lang=js"
export * from "./add_orthopedic_procedures_modal.vue?vue&type=script&lang=js"

import "./add_orthopedic_procedures_modal.vue?vue&type=style&index=0&id=13cfc63f&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cfc63f"]])

export default __exports__